import React from "react"
import { useRouteLoaderData } from "react-router-dom"
import { CurrentOrg, CurrentUser } from "../lib/store"

import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  FormControl,
  FormLabel,
  Select,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react"
import { SettingsIcon, QuestionIcon } from "@chakra-ui/icons"
import Link from "./Link"

export default function ProfileMenu() {
  const user = useRouteLoaderData("auth")
  const [currentOrg] = CurrentOrg.useState()
  const [currentUser] = CurrentUser.useState()

  const isMobile = useBreakpointValue({ base: true, md: false })

  if (!user) return null

  const getFullName = () => {
    if (currentUser.first_name && currentUser.last_name) {
      return `${currentUser.first_name} ${currentUser.last_name}`
    }
    return currentUser.email
  }

  const menuContent = (
    <Stack direction="column" bgColor="Primary.700">
      <FormControl>
        <FormLabel fontSize="xs">Organization:</FormLabel>
        <Select
          id="org-select"
          size={"xs"}
          label="org-select"
          defaultValue={""}
        >
          <option value="">{currentOrg.name}</option>
        </Select>
      </FormControl>
      <Link to="/account">
        <Text color="white" fontSize="sm">
          Account Settings
        </Text>
      </Link>
      <Link to="https://docs.blindinsight.io" target="_blank" rel="noreferrer">
        <Text color="white" fontSize="sm">
          API Docs
        </Text>
      </Link>
      <Link
        onClick={() => {
          window.Intercom("show")
        }}
      >
        <Text color="white" fontSize="sm">
          Help <QuestionIcon />
        </Text>
      </Link>
      <Link color="white" fontSize="sm" to="/logout">
        Logout
      </Link>
    </Stack>
  )

  if (isMobile) {
    return (
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          icon={<SettingsIcon height="100%" />}
          variant="ghost"
          color="white"
          boxSize={12}
          p={0}
          mr={4}
        />
        <MenuList>
          <MenuItem>
            <FormControl>
              <FormLabel>Organization:</FormLabel>
              <Select id="org-select" label="org-select" defaultValue={""}>
                <option value="">{currentOrg.name}</option>
              </Select>
            </FormControl>
          </MenuItem>
          <MenuItem as={Link} to="/account">
            Account Settings
          </MenuItem>
          <MenuItem
            as={Link}
            to="https://docs.blindinsight.io"
            target="_blank"
            rel="noreferrer"
          >
            API Docs
          </MenuItem>
          <MenuItem
            as={Link}
            onClick={() => {
              window.Intercom("show")
            }}
          >
            Help <QuestionIcon ml={2} />
          </MenuItem>
          <MenuItem as={Link} to="/logout">
            Logout
          </MenuItem>
        </MenuList>
      </Menu>
    )
  }

  return (
    <Accordion variant="standard" allowToggle w="100%" flexShrink={0}>
      <AccordionItem>
        <AccordionButton>
          <Text color="white" fontSize="sm" noOfLines={1}>
            {getFullName()} <SettingsIcon />
          </Text>
        </AccordionButton>
        <AccordionPanel>{menuContent}</AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}
